/**
 * P2 Stagger wobble — pure math.
 *
 * Persistent state-driven animation: while `mech.staggered === true`,
 * the chassis swims with a low-amplitude wobble around its vertical
 * axis (sub-Hz tilt around X + Z). The chassis is unbalanced; the
 * wobble cosmetic-only signals that the next turn the engine will
 * resolve recovery.
 *
 * Pure function — no Three deps so it unit-tests cleanly.
 */

/** Hz frequency of the wobble (cycles per second). */
export const STAGGER_FREQ_HZ = 1.5;
/** Peak tilt amplitude on each axis (radians). ~0.04 rad ≈ 2.3°. */
export const STAGGER_AMPLITUDE_RAD = 0.04;

export interface StaggerOffset {
  tiltX: number;
  tiltZ: number;
}

const REST: StaggerOffset = { tiltX: 0, tiltZ: 0 };

/**
 * Stagger tilt offsets for the current wall-clock time. Returns rest
 * when not staggered. The two axes are phase-offset by π/2 so the
 * chassis nutates rather than swinging back-and-forth on one axis.
 */
export function staggerOffset(staggered: boolean, nowMs: number): StaggerOffset {
  if (!staggered) return REST;
  const phase = (nowMs / 1000) * STAGGER_FREQ_HZ * Math.PI * 2;
  return {
    tiltX: Math.sin(phase) * STAGGER_AMPLITUDE_RAD,
    tiltZ: Math.cos(phase) * STAGGER_AMPLITUDE_RAD,
  };
}
